import { MSG, wa } from "../../data/site";
import { WhatsAppIcon } from "./Icons";
import { Reveal } from "./Reveal";

export const FinalCta = () => (
    <section
        id="agendar"
        data-testid="final-cta-section"
        className="relative overflow-hidden bg-[#1A6AFF] py-24 md:py-28"
    >
        <div
            className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-white/10 blur-2xl"
            aria-hidden="true"
        />
        <div
            className="pointer-events-none absolute -bottom-32 -left-16 h-96 w-96 rounded-full bg-[#0052E0]/60 blur-3xl"
            aria-hidden="true"
        />
        <div className="relative mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
            <Reveal>
                <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
                    Precisa de um tratamento de canal?
                </h2>
            </Reveal>
            <Reveal delay={0.1}>
                <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-blue-100 md:text-lg">
                    Entre em contato para esclarecer suas dúvidas e verificar a disponibilidade de
                    atendimento com o Dr. Gabriel Riccio.
                </p>
            </Reveal>
            <Reveal delay={0.2}>
                <a
                    href={wa(MSG.consulta)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="final-cta-whatsapp-button"
                    className="mt-9 inline-flex items-center gap-2.5 rounded-full bg-white px-8 py-4 text-sm font-bold text-[#1A6AFF] shadow-2xl shadow-blue-900/30 transition-all duration-300 hover:-translate-y-0.5 hover:bg-blue-50"
                >
                    <WhatsAppIcon className="h-5 w-5" />
                    Agendar minha consulta
                </a>
            </Reveal>
        </div>
    </section>
);
